import React from "react";

const PrivacyPolicy = () => {
  return (
    <section className="inner-page">
      <div className="container">
        <h1>IT Assist Experts Privacy Policy</h1>
        <p>
          IT Assist Experts collects the information you choose to submit through
          this website, including your name, email address, phone number, service
          request details, and product inquiry details.
        </p>
        <h2>How We Use Information</h2>
        <p>
          We use submitted information to respond to inquiries, schedule or
          provide technology assistance, follow up on product or service
          requests, improve our website, and maintain business records.
        </p>
        <h2>Lead Forms and Google Sheets</h2>
        <p>
          Form submissions may be sent to a Google Sheets document through a
          Google Apps Script web app configured by IT Assist Experts. Access to
          that sheet should be limited to authorized team members.
        </p>
        <h2>Cookies and Analytics</h2>
        <p>
          This website may use cookies, Google Tag Manager, and related analytics
          tools to understand website usage and improve marketing performance.
          Your browser settings may allow you to limit or block cookies.
        </p>
        <h2>Sharing</h2>
        <p>
          We do not sell submitted contact information. We may share information
          with service providers who help operate the website, process requests,
          or support customer communication, and when required by law.
        </p>
        <h2>Contact</h2>
        <p>
          To request access, correction, or deletion of your submitted
          information, contact support@itassistexperts.com.
        </p>
      </div>
    </section>
  );
};

export default PrivacyPolicy;
